import React, { useEffect, useState, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { getAboutData } from "../../data/about.js";
import "./about-us.css";

const AboutPage = () => {
  const aboutData = getAboutData();
  const { intro, founders, achievements, team } = aboutData;

  const [timelineProgress, setTimelineProgress] = useState(0);
  const timelineRef = useRef(null);

  useEffect(() => {
    const element = timelineRef.current;
    if (!element) return;

    const handleScroll = () => {
      const windowHeight =
        window.innerHeight || document.documentElement.clientHeight;
      const scrollY = window.scrollY || window.pageYOffset;
      const start = element.offsetTop - windowHeight;
      const end = element.offsetTop + element.offsetHeight;

      const rawProgress = (scrollY - start) / (end - start);
      const clamped = Math.min(Math.max(rawProgress, 0), 1);
      setTimelineProgress(clamped);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  return (
    <section className="about-page">

      <Container fluid className="col-12 mx-auto about-hero">
        <Row className="justify-content-center m-0 p-0">
          <Col xs={11} sm={11} md={10} lg={10}>
            <h1 className="about-title">{intro.heading}</h1>
            {intro.paragraphs.map((text, i) => (
              <p key={i} className="about-text">{text}</p>
            ))}
          </Col>
        </Row>

        <Row className="mt-5 col-12 col-md-10 mx-auto text-center justify-content-center">
          {founders.map((item) => (
            <Col
              xl={4}
              lg={5}
              md={6}
              sm={12}
              key={item.id}
              className="mb-4 d-flex justify-content-center"
            >
              <div className="founder-card">
                <img
                  src={item.image}
                  alt={item.role}
                  className="img-fluid founder-img"
                />
                <h4 className="founder-role mt-3">{item.role}</h4>
              </div>
            </Col>
          ))}
        </Row>
      </Container>

      <section className="achievement-section ">
        <Container fluid className="col-md-10 mx-auto">
          <h2 className="section-heading text-center">{achievements.heading}</h2>

          <div className="timeline" ref={timelineRef}>
            <div
              className="timeline-progress"
              style={{ height: `${timelineProgress * 100}%` }}
            />
            {achievements.items.map((item, index) => (
              <div
                key={item.id}
                className={`timeline-item ${
                  index % 2 === 0 ? "left" : "right"
                }`}
              >
                <div className="timeline-content">
                  <h5>{item.title}</h5>
                  <p>{item.description}</p>
                </div>

                <div
                  className={`timeline-middle ${
                    index % 2 === 0 ? "even" : ""
                  }`}
                >
                  <div className="timeline-icon">
                    <img
                      src={item.icon?.default || item.icon}
                      alt={item.title}
                    />
                  </div>
                  <span className="timeline-year my-auto">{item.year}</span>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>

      <section className="team-section">
        <Container fluid className="col-12 p-0 m-0 mx-auto">
          <h2 className="section-heading text-center">
            {team.heading}
          </h2>

          <div className="team-carousel-wrapper">
            <Swiper
              modules={[Autoplay]}
              spaceBetween={20}
              slidesPerView={1}
              loop={true}
              loopedSlides={team.members.length}
              loopAdditionalSlides={2}
              speed={800}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
                reverseDirection: false,
              }}
              allowTouchMove={true}
              grabCursor={true}
              breakpoints={{
                576: {
                  slidesPerView: 1,
                  spaceBetween: 15,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 15,
                },
                992: {
                  slidesPerView: 4,
                  spaceBetween: 20,
                },
              }}
              className="team-carousel"
            >
            {[...team.members, ...team.members].map((member, index) => (
              <SwiperSlide key={`${member.id}-${index}`}>
                <div className="team-card">
                  <div className="team-img-wrapper">
                    <img src={member.image} alt={member.name} className="img-fluid team-img" />
                  </div>
                  <h6 className="team-name">{member.name}</h6>
                  <p className="team-role">{member.role}</p>
                  <p className="team-class">{member.class}</p>
                </div>
              </SwiperSlide>
            ))}
            </Swiper>
          </div>
        </Container>
      </section>
    </section>
  );
};

export default AboutPage;